import { ModuleConditionTypeEnum } from "../../../types";
import ConfigCondition from "../../ConfigCondition";
import { UserTypeEnum } from "./types";

export default class UserTypeCondition extends ConfigCondition {
  type: ModuleConditionTypeEnum = ModuleConditionTypeEnum.UserType;

  value: UserTypeEnum = UserTypeEnum.IsPremium
}
